<template>
  <div class="">
    <div class="map-legend">
      <div class="legend-scale d-flex justify-content-center">
        <ul class="legend-labels">
          <li><span style="background: #41b883"></span> Male</li>
          <li><span style="background: #4b7cf3"></span> Female</li>
        </ul>
      </div>
    </div>
    <vue-chartist
      class="height-200"
      type="Pie"
      :data="labelsPieData"
      :options="labelsPieOptions"
    />
  </div>
</template>

<script>
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import VueChartist from 'v-chartist'
export default {
  name: 'PieChartLegends',
  components: {
    'vue-chartist': VueChartist,
  },
  props: ['maleCount', 'femaleCount'],
  watch: {
    maleCount() {
      this.labelsPieData.series[0].value = this.femaleCount
      this.labelsPieData.series[1].value = this.maleCount
    },
  },
  data() {
    return {
      labelsPieData: {
        series: [
          {
            value: this.femaleCount,
          },
          {
            value: this.maleCount,
          },
        ],
        showLabel: true,
      },
      labelsPieOptions: {
        // labelInterpolationFnc(value) {
        //   return value[0]
        // },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
    }
  },
}
</script>

<style scoped>
.class1 {
  color: #4b7cf3;
}
.map-legend .legend-title {
  text-align: left;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 50%;
  font-family: 'Mukta';
}
.map-legend .legend-scale ul {
  margin: 20px;
  padding: 0;
  list-style: none;
}
.map-legend .legend-scale ul li {
  display: block;
  width: 100px;
  margin-bottom: 6px;
  margin-left: 15px;
  text-align: left;
  font-size: 100%;
  list-style: none;
}
.map-legend ul.legend-labels li span {
  display: inline;
  float: left;
  height: 25px;
  width: 30px;
  margin-right: 15px;
}
.map-legend .legend-source {
  font-size: 70%;
  color: #999;
  clear: both;
}
.map-legend a {
  color: #777;
}
</style>
